import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const UserOut: FC<IIconsProps> = ({
  color,
  size = IconScale.S,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
        fill={color}
      />
    </svg>
  );
};

export default UserOut;
